import React from "react";
import ReactDatePicker from "react-date-picker";

import { HELMET_HTML_BY_LANG } from "../../../utils/consts";
import getLanguageFromUrl from "../../../utils/getLanguageFromUrl";

// Без locale react-calendar бере мову з браузера, а не з інтерфейсу
const DatePicker = (props) => {
  return (
    <ReactDatePicker
      locale={HELMET_HTML_BY_LANG[getLanguageFromUrl()]}
      {...props}
    />
  );
};

export default DatePicker;